// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"7860269c","619":"acc52ee3","767":"e823892d"}[chunkId] + ".chunk.css";
};